import { AppBox } from "../../../../../commons/components";
import { ManageFootballSubTeam } from "../../../../../commons/models/football/admin/manage-football-sub-team";

interface SubTeamDeleteProps {
  subTeam: ManageFootballSubTeam;
}
export default function SubTeamDelete({ subTeam }: SubTeamDeleteProps) {
  return (
    <AppBox displayBlock>
      Do you want to delete <strong>“{subTeam.name}”</strong> permanently? Once you delete the sub-team, the action
      cannot be undone.
    </AppBox>
  );
}
